import script from "./DeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=6d2784e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2784e8"]])

export default __exports__